import { render, staticRenderFns } from "./FullDescription.vue?vue&type=template&id=864f4004"
import script from "./FullDescription.vue?vue&type=script&lang=js"
export * from "./FullDescription.vue?vue&type=script&lang=js"
import style0 from "./FullDescription.vue?vue&type=style&index=0&id=864f4004&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports